import React, { useState, useCallback, useMemo, useRef, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util/';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import ApportionmentsList from '../ApportionmentsList';
import ChangeHighlightedImmutableUnderReviewControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
export const EmployeeActivityRow = _ref => {
  let {
    index,
    claim,
    sortedClaimProjectReports,
    headerScrollPosition,
    claimEmployees,
    refreshClaim,
    setClaimEmployees,
    claimEmployeesService,
    renderStateSelect,
    claimEmployeeRndApportionmentsService,
    isShowInvolvement
  } = _ref;
  const claimEmployee = useMemo(() => {
    return {
      ...claimEmployees[index]
    };
  }, [claimEmployees, index]);
  const [hasError, setHasError] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);
  const claimEmployeeRndApportRef = useRef(null);
  useEffect(() => {
    if (claimEmployeeRndApportRef.current) {
      claimEmployeeRndApportRef.current.scrollTo({
        left: headerScrollPosition
      });
    }
  }, [claimEmployeeRndApportRef, headerScrollPosition]);
  const updateEmployees = useCallback(employee => {
    const newEmployees = [...claimEmployees];
    newEmployees[index] = {
      ...employee
    };
    setClaimEmployees([...newEmployees]);
  }, [claimEmployees, index, setClaimEmployees]);
  const handleApportionmentChange = useCallback(async (employee, apportionment) => {
    const oldApportionment = employee.claim_employee_rnd_apportionments.find(a => a.claim_project_report_id === apportionment.claim_project_report_id);
    const index = employee.claim_employee_rnd_apportionments.indexOf(oldApportionment);
    const newApportionments = [...employee.claim_employee_rnd_apportionments];
    if (index === -1) {
      newApportionments.push(apportionment);
    } else {
      newApportionments[index] = {
        ...apportionment
      };
    }
    const updatedEmployee = await claimEmployeesService.get(employee);
    updatedEmployee.claim_employee_rnd_apportionments = newApportionments;
    updateEmployees(updatedEmployee);
  }, [updateEmployees]);
  const handleChange = useCallback(event => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    claimEmployee[event.target.name] = value;
    updateEmployees(claimEmployee);
  }, [updateEmployees, claimEmployee]);
  const saveChange = useCallback(() => {
    let method;
    if (claimEmployee.id) {
      method = 'update';
    } else {
      method = 'create';
    }
    claimEmployeesService[method](claimEmployee).then(claimEmployee => {
      setHasError(false);
      updateEmployees(claimEmployee);
      refreshClaim();
    }).catch(e => {
      setHasError(true);
      dispatch(handleError(e));
    });
  }, [updateEmployees, refreshClaim, claimEmployee, dispatch]);
  const hasPermissions = () => {
    return user.account_type !== 'customer' && user.account_type !== 'accountant';
  };
  return /*#__PURE__*/React.createElement("tr", {
    className: hasError ? 'bg-warning' : ''
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Control,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    disabled: true,
    name: "name",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Control,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    disabled: true,
    name: "role",
    type: "text",
    placeholder: "Please enter employees role",
    size: "sm"
  })), renderStateSelect && renderStateSelect(handleChange, saveChange, claimEmployee), isShowInvolvement && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    decimalScale: 1,
    onChange: handleChange,
    onBlur: saveChange,
    object: claimEmployee,
    disabled: claim.financials_locked || user.account_type === 'customer',
    name: "direct_rnd_apportionment",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    decimalScale: 1,
    onChange: handleChange,
    onBlur: saveChange,
    object: claimEmployee,
    disabled: claim.financials_locked || user.account_type === 'customer',
    name: "indirect_rnd_apportionment",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    decimalScale: 1,
    onChange: e => handleChange(e),
    onBlur: saveChange,
    object: claimEmployee,
    disabled: claim.claim_group.project_methodology !== 'employee_basis' || !hasPermissions(),
    name: "rnd_apportionment",
    type: "text",
    size: "sm"
  }))), claim.claim_group.project_methodology === 'project_basis' && /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ApportionmentsList, {
    claim: claim,
    headerScrollPosition: headerScrollPosition,
    claimEmployeeRndApportRef: claimEmployeeRndApportRef,
    sortedClaimProjectReports: sortedClaimProjectReports,
    handleApportionmentChange: handleApportionmentChange,
    claimEmployeeRndApportionmentsService: claimEmployeeRndApportionmentsService,
    model: claimEmployee,
    apportionmentable_type: "UkSection::ClaimEmployee",
    isShowInvolvement: isShowInvolvement
  })), !isShowInvolvement && /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    decimalScale: 1,
    onChange: e => handleChange(e),
    onBlur: saveChange,
    object: claimEmployee,
    disabled: claim.claim_group.project_methodology !== 'employee_basis' || !hasPermissions(),
    name: "rnd_apportionment",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    disabled: true,
    object: claimEmployee,
    name: "net_amount",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: FormattedNumberInput,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    disabled: true,
    object: claimEmployee,
    name: "rnd_amount",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    onChange: async e => {
      await handleChange(e);
      saveChange();
    },
    as: Form.Check,
    name: "group_as_various",
    disabled: claim.financials_locked || !hasPermissions(),
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    }
  })));
};